import { render, staticRenderFns } from "./SelectedNum.vue?vue&type=template&id=f0780886&scoped=true"
import script from "./SelectedNum.vue?vue&type=script&lang=js"
export * from "./SelectedNum.vue?vue&type=script&lang=js"
import style0 from "./SelectedNum.vue?vue&type=style&index=0&id=f0780886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0780886",
  null
  
)

export default component.exports